export const truncate = (string, maxLength) =>
  string.length > maxLength ? `${string.substring(0, maxLength - 2)}...` : string;
